import { CircularProgress } from '@material-ui/core';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      marginTop: theme.spacing(25),
      marginBottom: theme.spacing(2),
      textAlign: 'center',
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(15)
      }
    }
  })
);

interface LoadingProps {
  text: string;
}

export default function Loading({ text }: LoadingProps) {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <CircularProgress />
      <p>{text}</p>
    </div>
  );
}
